module.exports = __webpack_public_path__ + "static/bounce-logo-a6b8d70443bed3784eb6ec8b9fbc3a27.svg";